export default __webpack_public_path__ + "static/media/business-travel.073fe061.svg";